function cropUrl(baseUrl, w, h) {
    const separator = baseUrl.includes("?") ? "&" : "?";
    return `${baseUrl}${separator}auto=compress&cs=tinysrgb&fit=crop&w=${w}&h=${h}`;
}

export { cropUrl };
